/* __next_internal_client_entry_do_not_use__ FooterBanner auto */import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getDetailUrl, getUpdateTime, notLoginHandle } from "@/helpers/blog";
import { useTranslations } from "next-intl";
import { useEffect } from "react";
export const FooterBanner = param => {
  let {
    latest
  } = param;
  const t = useTranslations();
  useEffect(() => {
    document.addEventListener("click", e => {
      var _current_parentElement, _current_parentElement1;
      let current = e.target;
      if (!current) return;
      if ((current === null || current === void 0 ? void 0 : current.id) === "TryIt" || (current === null || current === void 0 ? void 0 : (_current_parentElement = current.parentElement) === null || _current_parentElement === void 0 ? void 0 : _current_parentElement.id) === "TryIt") {
        notLoginHandle();
      }
      let classList = [...current.classList];
      let parentClassList = [...((current === null || current === void 0 ? void 0 : (_current_parentElement1 = current.parentElement) === null || _current_parentElement1 === void 0 ? void 0 : _current_parentElement1.classList) || [])];
      if (classList.includes("") || parentClassList.includes("register-dom")) {
        notLoginHandle();
      }
    });
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: "footer-banner",
    children: [/*#__PURE__*/_jsx("div", {
      className: "latest-article-container",
      children: /*#__PURE__*/_jsxs("div", {
        className: "latest-article",
        children: [/*#__PURE__*/_jsx("p", {
          className: "latest-article-title",
          children: t("Seo_Footer_Latest_From")
        }), /*#__PURE__*/_jsx("div", {
          className: "latest-article-list",
          children: latest.map((item, index) => {
            return /*#__PURE__*/_jsxs("a", {
              className: "latest-article-item",
              href: getDetailUrl(item.urlName, item.language),
              target: "_blank",
              children: [/*#__PURE__*/_jsx("p", {
                className: "latest-article-item-category",
                children: item.category
              }), /*#__PURE__*/_jsx("p", {
                className: "latest-article-item-title",
                children: item.title
              }), /*#__PURE__*/_jsx("div", {
                className: "latest-article-item-date article-time",
                children: getUpdateTime(item.updateDate)
              })]
            }, index);
          })
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "user-guide",
      children: [/*#__PURE__*/_jsx("p", {
        className: "user-guide-title",
        children: t("Seo_Footer_Title")
      }), /*#__PURE__*/_jsx("p", {
        className: "user-guide-desc",
        children: t("Seo_Footer_Desc")
      }), /*#__PURE__*/_jsx("p", {
        onClick: notLoginHandle,
        className: "user-guide-button",
        children: t("Seo_Footer_Button")
      }), /*#__PURE__*/_jsx("p", {
        className: "user-guide-button-desc",
        children: t("Seo_Footer_Button_Desc")
      })]
    })]
  });
};